import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Inject } from 'inversify-props';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { ReportService } from '@/services/report.service';
import { ReportActions } from '@/constants/actions.constants';
import { ReportMutations } from '@/constants/mutation.constants';
import { BillingReportRequest } from '@/models/DTO/report/billing-report-request.model';

export const REPORT_MODULE_NAME = 'report';

class DefaultState {
  public showDownloading = false;
  public reportErrorResponse: BaseAPIErrorModel | null = null;
}

const defaultState = new DefaultState();

@Module({
  namespaced: true,
  name: REPORT_MODULE_NAME
})
export default class ReportModule extends VuexModule {
  @Inject()
  private readonly _reportService!: ReportService;

  public showDownloading = defaultState.showDownloading;
  public reportErrorResponse = defaultState.reportErrorResponse;

  @Action
  public async [ReportActions.getVeterinarianBillingReport](
    payload: BillingReportRequest
  ): Promise<string | null> {
    try {
      this.context.commit(ReportMutations.showReportDownloading, true);
      this.context.commit(ReportMutations.reportError, null);

      const response: string = await this._reportService.getBillingReport(
        payload.startDateUtc,
        payload.endDateUtc
      );

      return response;
    } catch (error) {
      console.log(error.response.data);

      const e = new BaseAPIErrorModel(error.response.data);

      this.context.commit(ReportMutations.reportError, e);
      return null;
    } finally {
      this.context.commit(ReportMutations.showReportDownloading, false);
    }
  }

  @Mutation
  private [ReportMutations.showReportDownloading](show: boolean) {
    this.showDownloading = show;
  }

  @Mutation
  private [ReportMutations.reset]() {
    Object.assign(this, defaultState);
  }

  @Mutation
  private [ReportMutations.reportError](errorModel: BaseAPIErrorModel | null) {
    this.reportErrorResponse = errorModel;
  }
}
